module.exports = __webpack_public_path__ + "src/assets/textures/tractor/start_engine_button.png";